import { Box, Card, Grid, Skeleton, Stack } from '@mui/material'

export function AdminLoadingState() {
  return (
    <Box aria-label="Loading admin data" aria-busy="true">
      <Stack spacing={1} sx={{ mb: 3 }}>
        <Skeleton variant="text" width={230} height={38} />
        <Skeleton variant="text" width="min(460px, 80%)" height={22} />
      </Stack>
      <Grid container spacing={2.5} sx={{ mb: 3 }}>
        {[0, 1, 2, 3].map((item) => (
          <Grid item xs={12} sm={6} md={3} key={item}>
            <Card sx={{ p: 2.5 }}>
              <Skeleton variant="text" width="45%" />
              <Skeleton variant="text" width="55%" height={48} />
              <Skeleton variant="text" width="70%" />
            </Card>
          </Grid>
        ))}
      </Grid>
      <Card sx={{ p: 2.5 }}>
        <Skeleton variant="text" width={160} height={26} sx={{ mb: 1 }} />
        {[0, 1, 2, 3].map((item) => <Skeleton key={item} variant="rectangular" height={42} sx={{ mb: 1, borderRadius: 1 }} />)}
      </Card>
    </Box>
  )
}
